import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-chase',
    templateUrl: './chase.component.html',
    styleUrls: ['./chase.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class ChaseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
